import { createContext, useContext } from 'react';

import { VENUES_TAXONOMY_KEY } from '@zola-helpers/client/dist/es/marketplace/vendorTaxonomyKeys';

import { VendorCardVendor } from '~/components/common/cards/util/types';

export type RecentlyViewedStorefrontsContextValues = {
  recentlyViewed: VendorCardVendor[];

  /**
   * Initially false, goes to true when the recently viewed API calls have completed
   */
  ready: boolean;
};

export const RecentlyViewedStorefrontsContext = createContext<
  RecentlyViewedStorefrontsContextValues | undefined
>(undefined);

export const useRecentlyViewedStorefronts = () => {
  const context = useContext(RecentlyViewedStorefrontsContext);
  if (context === undefined) {
    throw new Error(
      'useRecentlyViewedStorefronts must be used within a RecentlyViewedStorefrontsProvider'
    );
  }
  return context;
};

// Doesn't really fit in the context, but hey

export const getRecentlyViewedVendorCardProps = (
  vendor: VendorCardVendor,
  queriedLocation: string | undefined
) => {
  const isNonVenueWithMarketServiceInfo = Boolean(
    vendor.taxonomyNodeKey !== VENUES_TAXONOMY_KEY && vendor.metroType !== null && queriedLocation
  );

  if (isNonVenueWithMarketServiceInfo) {
    return {
      showServiceLocation: true,
      queriedLocation: queriedLocation as string,
      showLocation: false,
    } as const;
  }
  return {
    showServiceLocation: false,
    showLocation: true,
  } as const;
};
